import React, { Children } from "react"
import * as styles from "./TileLayout.module.scss"

/**
 * TileLayout properties
 */
export type TileLayoutProps = {
  columns?: 1 | 2 | 3 | 4
  children: React.ReactNode
}

/**
 *
 */
const TileLayout = (props: TileLayoutProps) => {
  // console.debug("Rendering TileLayout", props)
  const itemCount = React.Children.count(props.children)
  let columns = Math.min(props.columns || 3, itemCount)

  if (itemCount === 4 && columns === 3) columns = 4 // poistetaan sarake, että viimeinen elementti ei veny koko ruudun leveyteen.

  return (
    <div className={`${styles.tiles} ${styles[`columns${columns}`]}`}>
      {Children.toArray(props.children).map((itm: any, i: number) => {
        if (!itm) return null
        return (
          <div key={i} className={styles.tile}>
            {itm}
          </div>
        )
      })}
    </div>
  )
}

export default TileLayout
